<template>
    <div class="MenuPill-MAIN">
        <div><img src="../assets/icon-cube.png" @click="setView('cube')"/></div>
        <div><img src="../assets/icon-brackets.png" @click="setView('parenthesis')"/></div>
        <div><img src="../assets/icon-accessibility.png" @click="setView('artists')"/></div>
        <div class="MenuPill-indicator" ref="indicator" v-show="['cube', 'parenthesis', 'artists'].includes(view)"></div>
    </div>
</template>

<script>
export default{
    name: 'MenuPill',
    data(){
        return{
            indicatorStyles: {
                cube: { left: '18px' },
                parenthesis: { left: '92px' },
                artists: { left: '167px' }
            }
        }
    },
    computed: {
        view() {
            return this.$route.name;
        }
    },
    methods: {
        setView(view){
            this.$router.push({ name: view });
        },

        applyIndicator() {
            if (!this.$refs.indicator) return;
            if (['cube', 'parenthesis', 'artists'].includes(this.view))
                this.$refs.indicator.style.left = this.indicatorStyles[this.view].left;
        }
    },
    mounted(){
        if(['cube', 'parenthesis', 'artists'].includes(this.view))
            this.$refs.indicator.style.left = this.indicatorStyles[this.view].left;
    },
    watch: {
        '$route.name'(){
            this.$nextTick(() => this.applyIndicator());
        }
    }
}
</script>

<style scoped lang="stylus">
max-w-h-sqr(n)
    max-width: n
    max-height: n
    
.MenuPill-MAIN
    display: flex
    align-items: center
    justify-content: space-between
    background-color: black
    height: 47px
    width: 180px
    max-width: 75vw
    position: fixed
    margin: auto
    left: 0
    right: 0
    bottom: 6vw
    border-radius: 100vw
    padding: 0 18px
    z-index: 1

    >div
        width: 30px
        aspect-ratio: 1/1
        display: flex
        align-items: center
        justify-content: center
        margin-top: 3px
        border-bottom: 3px solid transparent

        img
            max-w-h-sqr(30px)
            cursor: pointer

    :nth-child(2) img
        max-w-h-sqr(25px)

    :nth-child(3) img
        max-w-h-sqr(26px)

.MenuPill-indicator
    position: absolute
    align-self: center
    left: 18px
    left: 92px
    left: 167px
    transition: all 0.2s
    border-bottom: 3px solid #015AFF !important
</style>